export const groupTransactionsByPaymentId = (transactions) => {
  let resultWithPayment = [];
  let resultWithoutPayment = [];
  //If the paymentId is null, the docket would not be a combined payment
  const transWithoutPayment = transactions.filter((x) => x.paymentId === null);
  resultWithoutPayment = transWithoutPayment.map((item) => {
    item.isCombinedPayment = false;
    return item;
  });

  //If the paymentId is not null, try to combine the payments
  const transWithPayment = transactions.filter((x) => x.paymentId !== null);

  const paymentIds = transWithPayment.reduce((group, trans) => {
    const { paymentId } = trans;
    group[paymentId] = group[paymentId] ?? [];
    group[paymentId].push(trans);
    return group;
  }, {});

  for (const key in paymentIds) {
    const transactionsByPaymentId = paymentIds[key];
    // If payment only has one docket, display as normal row
    if (transactionsByPaymentId.length === 1) {
      transactionsByPaymentId[0].isCombinedPayment = false;
      const item = { ...transactionsByPaymentId[0] };
      resultWithPayment = [...resultWithPayment, item];
    } else {
      // If payment has multi dockets, display as expandable row
      let totalAmount = 0;

      const childItems = transactionsByPaymentId.map((trans) => {
        let item = { ...trans };
        item.transDateStr = '';
        item.transTypeStr = '';
        item.paymentTypeStr = '';
        totalAmount = totalAmount + item.amount;
        return item;
      });

      const firstItem = transactionsByPaymentId[0];
      let parentItem = { ...firstItem };
      parentItem.transcodeStr = 'Combined Payment';
      parentItem.amount = totalAmount;
      parentItem.isCombinedPayment = true;
      parentItem.__childrens = childItems;
      resultWithPayment = [...resultWithPayment, parentItem];
    }
  }

  return [...resultWithoutPayment, ...resultWithPayment].sort(
    (a, b) => new Date(b.transDate) - new Date(a.transDate)
  );
};
